/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IReportFilterState } from "../types";
import dayjs, { Dayjs } from "dayjs";

export const setSelectedReportTypeAction = (state: IReportFilterState, action: PayloadAction<string>) => {
  state.selectedReportType = action.payload;
};
export const setSelectedReportTaskAction = (state: IReportFilterState, action: PayloadAction<string>) => {
  state.selectedReportTask = action.payload;
};

export const setSelectedReportCreatedAction = (state: IReportFilterState, action: PayloadAction<Dayjs | null | undefined>) => {
  state.selectedReportCreated = action.payload;
};

export const resetReportFiltersAction = (state: IReportFilterState) => {
  state.selectedReportType = "";
  state.selectedReportTask = "";
  state.selectedReportCreated = dayjs(new Date()) || "";
};
